import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Opacity"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 4.5H7.5V7.5H4.5V4.5ZM7.5 7.5H10.5V10.5H7.5V7.5ZM10.5 4.5H13.5V7.5H10.5V4.5ZM16.5 4.5H19.5V7.5H16.5V4.5ZM4.5 10.5H7.5V13.5H4.5V10.5ZM10.5 10.5H13.5V13.5H10.5V10.5ZM16.5 10.5H19.5V13.5H16.5V10.5ZM4.5 16.5H7.5V19.5H4.5V16.5ZM10.5 16.5H13.5V19.5H10.5V16.5ZM16.5 16.5H19.5V19.5H16.5V16.5ZM13.5 7.5H16.5V10.5H13.5V7.5ZM7.5 13.5H10.5V16.5H7.5V13.5ZM13.5 13.5H16.5V16.5H13.5V13.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Opacity.vue"]]);
